import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { Wrapper, Header, NameWrapper, Row, Column, ButtonSection, InfoLabel, InputName } from './shared_details_form_styles';
import { addSubjectInstance } from '../actions/subjectInstanceActions';
import ScheduleManager from '../components/scheduleManager';
import styled from 'styled-components';

const LabelOfCheckbox = styled(Label)`

    flex-direction: row;
    align-self: flex-end;
    margin-bottom:0;
  
`;
const RowOnCreateStudent = styled(Row)`
@media (max-width:600px) {
    flex-direction: column;
} 
`;

const ColumnOnCreateStudent = styled(Column)`
@media (max-width:600px) {
    width:90%;
} 
`;

export const SubjectInstance = ({ subjectId, subjectName }) => {
  const [name, setName] = useState(subjectName);
  // const [price, setPrice] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [zoom_link, setZoom_link] = useState("");
  const [schedule, setSchedule] = useState([]);
  const [timeFormAction, setTimeFormAction] = useState(null);
  const [isSpecial, setIsSpecial] = useState(false);

  const dispatch = useDispatch();


  const handleSave = async () => {
    if (startDate != '' && endDate != '') {
      const formattedSchedule = schedule.map((time) => `${time.day} - ${time.hour}`);
      const input = {
        subjectId,
        startDate: new Date(startDate).toISOString(),
        endDate: new Date(endDate).toISOString(),
        price: isSpecial ? 100 : null,
        schedule: formattedSchedule,
        zoom_link,
      };
      dispatch(addSubjectInstance(input));
    }
  };

  return (
    <Wrapper>
      <Header style={{ margin: "0px" }}>
        <NameWrapper style={{ margin: "0px" }}>
          <InputName
            type="text"
            name="name"
            value={name}
            disabled={true}
            onChange={(e) => setName(e.target.value)}
          />

        </NameWrapper>

      </Header>
      <ScheduleManager
        schedule={schedule}
        setSchedule={setSchedule}
        timeFormAction={timeFormAction}
        setTimeFormAction={setTimeFormAction}
      />
      <RowOnCreateStudent style={{ marginTop: "10px" }}>
        <ColumnOnCreateStudent>
          <Label>
            Start Date:
            <Input
              type="date"
              name="startDate"
              placeholder='Start Date'
              value={startDate.split('T')[0]}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </Label>
          <Label>
           End Date:
            <Input
              type="date"
              name="endDate"
              placeholder='End Date'
              value={endDate.split('T')[0]}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </Label>
        </ColumnOnCreateStudent>
        <ColumnOnCreateStudent>
          {/* <Label>
            Precio Mensual:
            <Input
              type="text"
              name="price"
              placeholder='Precio Mensual'
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </Label> */}
          
          <Label>
            Link de Zoom:
            <Input
              type="text"
              name="zoom_link"
              placeholder='Link de Zoom'
              value={zoom_link}
              onChange={(e) => setZoom_link(e.target.value)}
            />
          </Label>
          <LabelOfCheckbox>
            Especial:
            <Input
              type="checkbox"
              name="isSpecial"
              checked={isSpecial}
              onChange={(e) => setIsSpecial(e.target.checked)}
            />
          </LabelOfCheckbox>
        </ColumnOnCreateStudent>
      </RowOnCreateStudent>
     {startDate != '' && endDate != '' && schedule.length>0 && <Button style={{ width: '50%' }} onClick={handleSave}>Save</Button>}
    </Wrapper>
  );
};

export default SubjectInstance;
